import { BoxList, StatusLabel, StatusLabelTypes } from '@factorialco/deprecated-design-system'
import { DocumentStatusesEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import StatusItem, {
  StatusStruct,
} from 'modules/documents/components/DocumentPreview/Content/StatusItem'
import type Log from 'modules/documents/store/models/Log'

interface Props {
  statusChangedLog: Log | undefined
  documentStatus: DocumentStatusesEnum
  employeeFullName: string
  employeeAvatarURL: string
}

const Status = ({
  statusChangedLog,
  documentStatus,
  employeeFullName,
  employeeAvatarURL,
}: Props) => {
  const toStatusStruct = (): StatusStruct => {
    return {
      signerFullName: employeeFullName,
      signerAvatar: employeeAvatarURL,
      statusText: getStatusText(documentStatus),
      statusDate: statusChangedLog?.attributes.created_at,
    }
  }

  const getTagColor = (status: DocumentStatusesEnum): StatusLabelTypes => {
    if (status === 'to_fill') return 'warning'
    if (status === 'filled') return 'positive'

    return 'info'
  }

  const getStatusText = (status: DocumentStatusesEnum): string => {
    return {
      to_fill: i18n.t('documents.modal.fillable.status.to_fill'),
      filled: i18n.t('documents.modal.fillable.status.filled'),
    }[status]
  }

  return (
    <BoxList>
      <StatusItem
        status={toStatusStruct()}
        statusBox={
          <StatusLabel ellipsis type={getTagColor(documentStatus)}>
            {getStatusText(documentStatus)}
          </StatusLabel>
        }
      />
    </BoxList>
  )
}

export default Status
